import ArrowForward from '@mui/icons-material/ArrowForward';

import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

export const MessageRoot = superstyled({
  name: 'MessageWithCTA',
  slot: 'Root',
  tag: Box,
  propsNeeded: ['variant'],
  styles: ({ theme, variant }) => ({
    marginBottom: theme.spacing(2),
    ...(variant === 'card' && {
      backgroundColor: theme.palette.background.grey.light,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(3),
      border: `1px solid ${theme.palette.border.main}`
    })
  })
});

export const MessageTitle = superstyled({
  name: 'MessageWithCTA',
  slot: 'Title',
  tag: Text,
  styles: ({ theme }) => ({
    marginBottom: theme.spacing(2),
    fontWeight: theme.typography.fontWeightBold
  })
});

export const MessageText = superstyled({
  name: 'MessageWithCTA',
  slot: 'Text',
  tag: Text,
  styles: ({ theme }) => ({
    whiteSpace: 'pre-wrap',
    marginBottom: theme.spacing(3),
    '& > * + *': {
      marginTop: theme.spacing(1)
    }
  })
});

export const CTAContainer = superstyled({
  name: 'MessageWithCTA',
  slot: 'CTAContainer',
  tag: Box,
  styles: ({ theme }) => ({
    marginTop: theme.spacing(3)
  })
});

export const ButtonContainer = superstyled({
  name: 'MessageWithCTA',
  slot: 'ButtonContainer',
  tag: Box,
  styles: ({ theme }) => ({
    marginTop: 'auto',
    paddingTop: theme.spacing(2),
    display: 'flex',
    gap: theme.spacing(1)
  })
});

export const TextHighlight = superstyled({
  name: 'MessageWithCTA',
  slot: 'TextHighlight',
  tag: Text,
  styles: ({ theme }) => ({
    color: theme.palette.secondary.main,
    fontWeight: 600
  })
});

export const ArrowForwardIcon = superstyled({
  name: 'MessageWithCTA',
  slot: 'ArrowForwardIcon',
  tag: ArrowForward,
  styles: ({ theme }) => ({
    marginLeft: theme.spacing(0.5),
    color: theme.palette.secondary.main,
    transition: 'transform 0.3s ease',
    '.MuiButton-root:hover &': {
      transform: 'translateX(6px)'
    }
  })
});
